import React, { useEffect, useRef, useState } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';
import { settingList } from './contants';
import { SettingItem } from './index.d';
import Http from '@helpers/Http';
import { Api } from '@apis/client';
import Filter from '@helpers/Filter';
import BrowserHistory from '@helpers/BrowserHistory';

const ClassDisableEntry = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [selfStatus, setSelfStatus] = useState(false);
  const [schoolStatus, setSchoolStatus] = useState(false);

  const renderSettingItem = () => {
    const getStatusText = (type: number): string => {
      switch(type) {
        case 2: {
          return schoolStatus ? '已开启' : '未开启';
        }
        default: {
          return selfStatus ? '已开启' : '未开启';
        }
      }
    }

    const onEntryClicked = (type: number) => {
      switch(type) {
        case 2: {
          if (schoolStatus) {
            BrowserHistory.push(`${PUBLIC_URL}/deviceClassDisableSchool?sncode=${params.current.sncode}&company=${params.current.company}`);
          }
          break;
        }
        default: {
          BrowserHistory.push(`${PUBLIC_URL}/deviceClassDisableSelf?sncode=${params.current.sncode}&company=${params.current.company}`);
          break;
        }
      }
    }

    const showRightArrow = (type: number): boolean => {
      if (type === 2 && !schoolStatus) {
        return false;
      }
      return true;
    }

    const items = settingList.map((item: SettingItem, index) => {
      return (
        <div key={index} className="flex" styleName="item" onClick={() => {onEntryClicked(item.type)}}>
          <div className="flex" styleName='item-title-row'>
            <span styleName="item-title">{ item.title }</span>
            <div className="flex" styleName='right-container'>
              <span styleName="item-status">{getStatusText(item.type)} </span>
              {showRightArrow(item.type) ? <i styleName='right-arrow' className="iconfont icon-tubiaoyanse" /> : null}
            </div>
          </div>
          <span styleName="item-desc">{ item.desc }</span>
        </div>
      )
    })
    return (
      <div styleName="list">
        {items}
      </div>
    )
  }

  const loadData = async() => {
    const { data } = await Http.post(Api.GetClassDisableSelfConfig, {
      sncode: params.current.sncode,
      company: params.current.company
    });
    if (data) {
      setSelfStatus(data.isDisableDuringClass || false);
    }

    const result = await Http.post(Api.GetClassDisableSchoolConfig, {
      sncode: params.current.sncode,
      company: params.current.company
    });
    if (result && result.data) {
      setSchoolStatus(result.data.status === 1);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div styleName="container">
      <NavBar
        title="上课免打扰"
      />
      { renderSettingItem() }
    </div>
  )
}

export default ClassDisableEntry;
